module.exports = __webpack_public_path__ + "kg.svg?300e8630f2c5b3b3a96619ffa5bec5ee";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/kg.svg
// module id = 1098
// module chunks = 27